import { render, staticRenderFns } from "./ContentLicenceAgreementModal.vue?vue&type=template&id=1d9e64fd"
import script from "./ContentLicenceAgreementModal.vue?vue&type=script&lang=js"
export * from "./ContentLicenceAgreementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports